import { last } from "es-toolkit";
export function redirectToStyle(style) {
    const currentView = last(location.pathname.split("/"));
    const { account: { name }, style: { key }, } = style;
    history.replaceState({}, "", `/${name}/maps/${key}/${currentView}`);
}
